function initSimpleVideoMute() {
  const section = document.querySelector(".about-video-media");
  if (!section) return;
  const videos = section.querySelectorAll("video");
  const btn = document.getElementById("muteToggle");
  if (!videos.length) return;
  videos.forEach(v => v.muted = true);
  updateIcon(true);
  btn?.addEventListener("click", () => {
    const isMuted = videos[0].muted;
    if (isInViewport(section)) {
      videos.forEach(v => v.muted = !isMuted);
      updateIcon(!isMuted);
    }
  });
  window.addEventListener("scroll", () => {
    if (!isInViewport(section)) {
      videos.forEach(v => v.muted = true);
      updateIcon(true);
    }
  });
}
function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0;
}
function updateIcon(isMuted) {
  const btn = document.getElementById("muteToggle");
  if (!btn) return;

  btn.classList.toggle("muted", isMuted);
  btn.classList.toggle("unmuted", !isMuted);
}
document.addEventListener("DOMContentLoaded", initSimpleVideoMute);
document.addEventListener("shopify:section:load", initSimpleVideoMute);